import { Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';
import { DebugHelperOptions } from './debug-helper.interface';
import { ENVIRONMENT_TOKEN } from '@rx-applications/shared/utils';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[debugHelper]',
})
export class DebugHelperDirective {
  readonly #el: ElementRef = inject(ElementRef);
  readonly #renderer = inject(Renderer2);
  readonly #appversion = inject(ENVIRONMENT_TOKEN).version;

  @Input() set debugHelperOptions(options: DebugHelperOptions) {
    if (options.enabled) {
      this.clearText();
      this.createDiv();
      this.appendText('cid', options.cid);
      this.addLine();
      this.appendText('app_version', this.#appversion);
    }
  }

  div: unknown;

  text: unknown;
  parent: unknown;

  createDiv() {
    this.div = this.#renderer.createElement('div');
    this.#renderer.addClass(this.div, 'f-color-light');
    this.#renderer.addClass(this.div, 'f-size-sm');
    this.#renderer.setStyle(this.div, 'position', 'fixed');
    this.#renderer.setStyle(this.div, 'bottom', '1rem');
    this.#renderer.setStyle(this.div, 'left', '1rem');
    this.#renderer.setStyle(this.div, 'z-index', '10');
    this.#renderer.setStyle(this.div, 'background', '#fff');
  }

  appendText(title: string, text: string) {
    this.text = this.#renderer.createText(`${title}: ${text}`);
    this.parent = this.#renderer.parentNode(this.#el.nativeElement);

    this.#renderer.appendChild(this.div, this.text);
    this.#renderer.appendChild(this.parent, this.div);
  }

  clearText() {
    if (this.parent && this.div) {
      this.#renderer.removeChild(this.parent, this.div);
    }
  }

  private addLine(): void {
    const br = this.#renderer.createElement('br');
    this.#renderer.appendChild(this.div, br);
  }
}
